/* eslint-disable global-require */
// Datos del comercio (fuente única de verdad para páginas legales, footer, login y recibos).
export default {
  name: "Telemon",
  legalName: "Telemon SRL.",
  website: "https://telemontv.com",
  logo: require("@/assets/images/logo/telemon-logo.png"),
  address: "Municipio Nagua, Provincia María Trinidad Sánchez, 33000",
  municipality: "Nagua",
  province: "María Trinidad Sánchez",
  postalCode: "33000",
  country: "República Dominicana",
  phone: "809-584-7676",
  email: "noc@telemontv.com",
  currency: "DOP",
  currencyLabel: "RD$",
}
